import { ApplicationConfig, ErrorHandler, inject, provideBrowserGlobalErrorListeners, provideAppInitializer } from '@angular/core';
import { provideRouter, Router, TitleStrategy } from '@angular/router';
import { provideHttpClient } from '@angular/common/http';
import { init } from '@plausible-analytics/tracker';
import * as Sentry from '@sentry/angular';
import { appRoutes } from './app.routes';
import { AppTitleStrategy } from './title-strategy';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(appRoutes),
    provideHttpClient(),
    { provide: TitleStrategy, useClass: AppTitleStrategy },
    provideAppInitializer(() => init({ domain: 'theperfectmuse.com' })),
    { provide: ErrorHandler, useValue: Sentry.createErrorHandler() },
    { provide: Sentry.TraceService, deps: [Router] },
    provideAppInitializer(() => { inject(Sentry.TraceService); }),
  ],
};
